import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { RecordTypeEntity } from './record-type.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum RecordTypeActionTypes {
  LoadRecordTypes = '[RecordType] Load RecordTypes',
  AddRecordType = '[RecordType] Add RecordType',
  UpsertRecordType = '[RecordType] Upsert RecordType',
  AddRecordTypes = '[RecordType] Add RecordTypes',
  UpsertRecordTypes = '[RecordType] Upsert RecordTypes',
  UpdateRecordType = '[RecordType] Update RecordType',
  UpdateRecordTypes = '[RecordType] Update RecordTypes',
  DeleteRecordType = '[RecordType] Delete RecordType',
  DeleteRecordTypes = '[RecordType] Delete RecordTypes',
  ClearRecordTypes = '[RecordType] Clear RecordTypes',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadRecordTypes implements Action {
  public readonly type = RecordTypeActionTypes.LoadRecordTypes;

  constructor(public payload: { recordTypes: RecordTypeEntity[] }) {}
}

export class AddRecordType implements Action {
  public readonly type = RecordTypeActionTypes.AddRecordType;

  constructor(public payload: { recordType: RecordTypeEntity }) {}
}

export class UpsertRecordType implements Action {
  public readonly type = RecordTypeActionTypes.UpsertRecordType;

  constructor(public payload: { recordType: RecordTypeEntity }) {}
}

export class AddRecordTypes implements Action {
  public readonly type = RecordTypeActionTypes.AddRecordTypes;

  constructor(public payload: { recordTypes: RecordTypeEntity[] }) {}
}

export class UpsertRecordTypes implements Action {
  public readonly type = RecordTypeActionTypes.UpsertRecordTypes;

  constructor(public payload: { recordTypes: RecordTypeEntity[] }) {}
}

export class UpdateRecordType implements Action {
  public readonly type = RecordTypeActionTypes.UpdateRecordType;

  constructor(public payload: { recordType: Update<RecordTypeEntity> }) {}
}

export class UpdateRecordTypes implements Action {
  public readonly type = RecordTypeActionTypes.UpdateRecordTypes;

  constructor(public payload: { recordTypes: Update<RecordTypeEntity>[] }) {}
}

export class DeleteRecordType implements Action {
  public readonly type = RecordTypeActionTypes.DeleteRecordType;

  constructor(public payload: { id: string }) {}
}

export class DeleteRecordTypes implements Action {
  public readonly type = RecordTypeActionTypes.DeleteRecordTypes;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearRecordTypes implements Action {
  public readonly type = RecordTypeActionTypes.ClearRecordTypes;
}

export type RecordTypeActions =
  | LoadRecordTypes
  | AddRecordType
  | UpsertRecordType
  | AddRecordTypes
  | UpsertRecordTypes
  | UpdateRecordType
  | UpdateRecordTypes
  | DeleteRecordType
  | DeleteRecordTypes
  | ClearRecordTypes;
